/**
 * Generic formatter for entity lists
 * @param {Array} allItems - Array of all possible items
 * @param {Array} assignedItems - Array of assigned item IDs
 * @param {Object} options - Formatting options
 * @param {string} options.idKey - Key to use for ID matching (e.g., 'id', 'companyId')
 * @param {string} options.labelKey - Key to use for display text (e.g., 'title', 'internalName', 'name')
 * @param {number} [options.limit] - Character limit for the output string
 * @returns {string} Formatted string
 */
export const formatAssignedEntities = (allItems, assignedItems = [], options = {}) => {
    const { idKey = 'id', labelKey = 'title', limit = null } = options;

    if (!assignedItems?.length) {
        return '--';
    }

    let plainNames = '';
    let count = 0;

    allItems.forEach(item => {
        const id = item[idKey];
        const label = item[labelKey];

        if (assignedItems.includes(id)) {
            if (plainNames.length > 0) {
                plainNames += ', ' + label;
            } else {
                plainNames += label;
            }
            count += 1;
        }
    });

    const countPrefix = `(${count}) `;
    if (!limit) {
        return `${countPrefix}${plainNames}`;
    }
    return `${countPrefix}${plainNames.length > limit ? plainNames.substring(0, limit) + '...' : plainNames}`;
};

/**
 * Generic formatter for array of objects
 * @param {Array} items - Array of objects to format
 * @param {Object} options - Formatting options
 * @param {string} options.labelKey - Key to use for display text (e.g., 'title', 'internalName', 'name')
 * @param {number} [options.limit] - Character limit for the output string
 * @returns {string} Formatted string
 */
export const formatEntities = (items = [], options = {}) => {
    const { labelKey = 'title', limit = null } = options;

    if (!items?.length) {
        return '--';
    }

    let plainNames = '';
    const count = items.length;

    items.forEach((item, index) => {
        const label = item[labelKey];
        if (index === 0) {
            plainNames = label;
        } else {
            plainNames += ', ' + label;
        }
    });

    const countPrefix = `(${count}) `;
    if (!limit) {
        return `${countPrefix}${plainNames}`;
    }
    return `${countPrefix}${plainNames.length > limit ? plainNames.substring(0, limit) + '...' : plainNames}`;
};
